import {
  clampRepositoryBrowsePath,
  getParentRepositoryExplorerPath,
  getParentZipInternalPath,
  isOutsideRepositoryBrowseRoot,
  isRepositoryBrowseRootFolder,
  normalizeRepositoryExplorerPath,
  normalizeZipInternalPath,
} from './repository-assignment-path.util';

export interface RepositoryTableNavContext {
  repositorySearchActive: boolean;
  currentZipPath: string | null;
  currentPath: string;
}

export function canRepositoryTableNavBack(ctx: RepositoryTableNavContext): boolean {
  if (ctx.repositorySearchActive) {
    return true;
  }
  if (ctx.currentZipPath) {
    return true;
  }
  const current = normalizeRepositoryExplorerPath(ctx.currentPath);
  if (!current) {
    return false;
  }
  // En/fuera de Repositorio aún se puede Volver a la raíz lógica; en '' no.
  return true;
}

export type RepositoryZipGoUpResult =
  | { kind: 'leaveZip' }
  | { kind: 'navigate'; nextInternalPath: string };

export function resolveRepositoryZipGoUp(zipInternalPath: string): RepositoryZipGoUpResult {
  const internal = normalizeZipInternalPath(zipInternalPath);
  if (!internal) {
    return { kind: 'leaveZip' };
  }
  return { kind: 'navigate', nextInternalPath: getParentZipInternalPath(internal) };
}

/**
 * Sube un nivel; no sale de `/Repositorio`.
 * Desde la carpeta Repositorio o rutas `/home/...` ilegales → raíz `''`.
 */
export function resolveRepositoryFolderGoUp(currentPath: string): string | null {
  const current = normalizeRepositoryExplorerPath(currentPath);
  if (!current) {
    return null;
  }
  // Path ilegal (/home, /home/egs/datavault) o carpeta Repositorio → raíz lógica.
  if (isOutsideRepositoryBrowseRoot(current) || isRepositoryBrowseRootFolder(current)) {
    return '';
  }
  const parent = getParentRepositoryExplorerPath(current);
  if (!parent || isOutsideRepositoryBrowseRoot(parent) || isRepositoryBrowseRootFolder(parent)) {
    return '';
  }
  return clampRepositoryBrowsePath(parent);
}
